import SanityBlockContent from '~/components/sanity/SanityBlockContent.vue';
import RoundButton from '~/components/buttons/RoundButton.vue';
import RectangleButton from '~/components/buttons/RectangleButton.vue';
export default {
  name: 'CtaBtn',
  components: {
    RoundButton,
    RectangleButton,
    SanityBlockContent
  },
  props: {
    text: String,
    link: String,
    legal: {
      type: Array
      // default: [],
    },
    ratings: String,
    misc: {
      type: Array
      // default: [],
    },
    caption: {
      type: Array
      // default: [],
    },
    styles: Object
  },
  computed: {
    existingParams() {
      if (!this.$route.query) return null;
      return Object.keys(this.$route.query).map(key => {
        return `${key}=${this.$route.query[key]}`;
      }).join('&');
    },
    style() {
      const {
        color,
        fontSize,
        fontWeight,
        backgroundColor,
        borderColor,
        paddingHorizontal
      } = this.styles;
      const style = {
        ...(color && {
          color
        }),
        ...(fontSize && {
          fontSize: `${fontSize}px`
        }),
        ...(fontWeight && {
          fontWeight
        }),
        ...(backgroundColor && {
          backgroundColor
        }),
        ...(borderColor && {
          border: `2px solid ${borderColor}`
        }),
        ...(Number.isInteger(paddingHorizontal) && {
          paddingLeft: `${paddingHorizontal}px`,
          paddingRight: `${paddingHorizontal}px`
        })
      };
      return style;
    }
  }
};